import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	min-height: 100vh;
	align-items: center;
	flex-direction: column;
	background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
`;
